export default __webpack_public_path__ + "static/media/Logo.25e897aa.svg";